import { Injectable } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { LanguageSelectionComponent } from "@core/components/language-selection/language-selection.component";
import { LOCAL_STORAGE_LANG_KEY } from "@core/constants/app";

@Injectable({ providedIn: "root" })
export class LanguageSelectionModalService {
    private activeModal: NgbModalRef | null = null;

    constructor(private modalService: NgbModal) {}

    // USE TWO FOLLOWING FUNCTION WHEN LANGUAGE SELECTION FLOW CHANGES
    openInitialSetupIfNeeded(): void {
        if (localStorage.getItem(LOCAL_STORAGE_LANG_KEY)) {
            return;
        }
        this.open({ initialSetup: true });
    }
    //
    openChangeLanguage(): void {
        this.open({ initialSetup: false });
    }

    // REMOVE WHEN LANGUAGE SELECTION FLOW CHANGES
    openOnDashboardLoad(): void {
        const hasSavedLang = !!localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
        this.open({ initialSetup: !hasSavedLang });
    }

    private open(options: { initialSetup: boolean }): void {
        if (this.activeModal) {
            return;
        }
        this.activeModal = this.modalService.open(LanguageSelectionComponent, {
            animation: false,
            backdrop: false,
            backdropClass: "language-selection-modal-backdrop",
            centered: false,
            container: "body",
            keyboard: false,
            windowClass: "language-selection-modal",
        });
        this.activeModal.componentInstance.initialSetup = options.initialSetup;
        this.activeModal.result.finally(() => {
            this.activeModal = null;
        });
    }
}
